import React from "react";
import { Typography } from "@mui/material";
import { styledIconSEO, styledTextSEO } from "../../SEO/MuiStyles";
import PriceChangeIcon from "@mui/icons-material/PriceChange";

const LeftInformation = () => {
  return (
    <>
      <PriceChangeIcon style={styledIconSEO} />
      <Typography variant="h4" style={{ fontWeight: "900", marginBottom: 15 }}>
        Precios
      </Typography>
      <Typography variant="caption" style={styledTextSEO}>
        Agrega los valores asociados a la moto.
      </Typography>
    </>
  );
};

export default LeftInformation;
